import { Injectable } from "@angular/core";
import { interval, Subject } from "rxjs";
import { catchError, takeWhile, tap } from "rxjs/operators";
import { BehaviorSubject, Observable } from "rxjs";
import { ToastController, LoadingController } from "@ionic/angular";
import { Global } from "../../global";

// import { Plugins, Capacitor } from "@capacitor/core";
import { Network } from "@capacitor/network"; // ✅ Correct import
import { Capacitor } from "@capacitor/core";
import { HttpClient } from "@angular/common/http";
// import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

//const { Network } = Plugins;

export enum ConnectionStatus {
  Online,
  Offline,
}

@Injectable({
  providedIn: "root",
})
export class NetworkService {
  private status: BehaviorSubject<ConnectionStatus> = new BehaviorSubject(
    ConnectionStatus.Online
  );
  private loading: any = null;
  private returnData: any;
  constructor(
    private toastController: ToastController,
    private loadingCtrl: LoadingController,
    public globals: Global,
    private http: HttpClient
  ) {
    console.log("NetworkService::constructor | method called");

    let status = ConnectionStatus.Online;
    // if (Capacitor.platform === 'web') {
    //   console.log('WEB');
    //   console.log('navigator.onLine', navigator.onLine);
    //
    this.addConnectivityListenersToBackend();
    //   status =  navigator.onLine === true ? ConnectionStatus.Online : ConnectionStatus.Offline;
    // } else { // Native: use capacitor network plugin
    //   console.log('NATIVE');
    //   this.addConnectivityListernerNative();
    //   // status = Network.getStatus();
    // }

    ////////////////////////////
    //////////////////////////// Need to uncomment if working Online again
    //this.addConnectivityListenersToBackend();
    this.status.next(status);
  }

  onOnline() {
    if (this.status.getValue() === ConnectionStatus.Offline) {
      console.log("Network connected!");
      console.log("navigator.onLine", navigator.onLine);
      this.dismissLoading();
      this.globals.IsOnline = true;
      this.updateNetworkStatus(ConnectionStatus.Online);
    }
  }

  onOffline() {
    if (this.status.getValue() === ConnectionStatus.Online) {
      console.log("Network was disconnected :-(");
      console.log("navigator.onLine", navigator.onLine);
      this.globals.IsOnline = false;
      //this.presentLoading();
      this.updateNetworkStatus(ConnectionStatus.Offline);
    }
  }

  addConnectivityListenersToBackend() {
    interval(2000).subscribe(() => {
      this.http
        .get(this.globals.XRSBackendURL + "CheckXRSBackendConnection")
        .subscribe(
          (data) => {
            try {
              this.returnData = true;
            } catch {
              this.returnData = false;
            }
          },
          (error) => {
            this.returnData = false;
          }
        );
      console.log(this.returnData);

      this.returnData === true ? this.onOnline() : this.onOffline();
    });
  }

  callBackend() {
    return this.http
      .get(this.globals.XRSClickerBaseURL + "CheckXRSBackendConnection")
      .pipe(
        tap((res) => {
          try {
            const returnData1 = res;
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }
  addConnectivityListenersBrowser() {
    window.addEventListener("online", this.onOnline.bind(this));
    window.addEventListener("offline", this.onOffline.bind(this));
  }

  addConnectivityListernerNative() {
    const handler = Network.addListener("networkStatusChange", (status) => {
      console.log("Network status changed", status);
    });
  }

  private async updateNetworkStatus(status: ConnectionStatus) {
    console.log("updateNetworkStatus", status);
    //this.status.next(status);

    // const connection = status === ConnectionStatus.Offline ? 'Offline' : 'Online';
    // const toast = await this.toastController.create({
    //   message: `You are now ${connection}`,
    //   duration: 3000,
    //   position: 'bottom'
    // });
    // toast.present();
  }

  public onNetworkChange(): Observable<ConnectionStatus> {
    return this.status.asObservable();
  }

  public getCurrentNetworkStatus(): ConnectionStatus {
    return this.status.getValue();
  }

  private async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      message: "Waiting for connection...",
    });

    return await this.loading.present();
  }

  private async dismissLoading() {
    if (this.loading !== null && typeof this.loading !== "undefined") {
      this.loading.dismiss();
      this.loading = null;
    }
  }
}
